import type { Outlet } from '@prisma/client'
export class OutletModel {
  table = 'outlet'
}

export type OutletType = Outlet & {
}